<template>
  <div>
    <v-divider class="divider-color"/>
    <v-list-tile :key="student.name" avatar>
      <v-list-tile-avatar color="primary">
        <img v-if="student.picture"
          class="img"
          :src="student.picture"
          :alt="student.name"
        >
        <v-icon v-else dark>account_circle</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content class="mr-2">
        <v-list-tile-title v-text="student.name"></v-list-tile-title>
        <v-list-tile-sub-title v-text="student.classroom"/>
      </v-list-tile-content>
      <v-list-tile-action class="list-action">
        <v-layout align-center row justify-center>
          <v-icon v-if="student.temporary" size="20" class="mr-2">access_time</v-icon>
          <v-checkbox v-model="checked" data-test="selection-checkbox"/>
        </v-layout>
      </v-list-tile-action>
    </v-list-tile>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'StudentRowSelectable',
  props: {
    student: {
      type: Object,
      default: null
    }
  },
  methods: {
    ...mapActions({
      updateStudentChecked: 'responsibleInfos/updateStudentChecked'
    })
  },
  computed: {
    checked: {
      get () {
        return this.student.checked
      },
      set (value) {
        const { id } = this.student
        this.updateStudentChecked({ value, id })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .list-action
    min-width auto

  .img
    overflow hidden
</style>
